module.exports = __webpack_public_path__ + "static/img/payme.b6b2dbea.svg";